const updateEstimatorValues = (_, variables, { cache }) => {
  const {
    term,
    financedAmount,
    msrp,
    downPayment,
    apr,
    estimatedPayment
  } = variables;
  const data = {
    configurator: {
      __typename: 'Configurator',
      financeEstimator: {
        __typename: 'Finance Estimator',
        term,
        financedAmount,
        msrp,
        downPayment,
        apr,
        estimatedPayment
      }
    }
  };
  cache.writeData({ data });
  return null;
};

export default updateEstimatorValues;
